import { combineEpics, Epic } from "redux-observable";
import { retrieveSuperAdminStatsEpic } from "../usecases/retrieveSuperAdminStats/retrieveSuperAdminStatsEpic";
import { retrieveCompanyStatsEpic } from "../usecases/retrieveCompanyStats/retrieveCompanyStats.epic";

export const statsRootEpics: Epic =  combineEpics(
    retrieveSuperAdminStatsEpic,
    retrieveCompanyStatsEpic
)
